import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice"
import { Link } from "react-router-dom";

export default function Landing2Launch() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-launch">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-launch-content">
                <div>
                  <h3 className="heading">Launch Your Taxi App – Under Your Brand</h3>
                  <p>Get branded rider and driver apps, an admin panel, and a taxi dispatch system — no coding required!</p>
                </div>
                <span>
                  <button onClick={() => dispatch(openPopup())} className="default-white">Schedule a Free Demo</button>
                 <Link to={"/features/taxi-software"}><button className="default-white">Explore Features</button></Link> 
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
